import formatDate from '@/module/util/format-date'
import appointmentSections from '../../appointment/sections'

function sectionTitle(key) {
    var section = appointmentSections.find((s) => (s.key == key))
    if (section)
        return section.title
}

export default function(patient, appointments) {
    var result = []
    var nextAppointment = null

    appointments.forEach((appointment) => {
        if (appointment.time - 86400000 > Date.now()) {
            if (nextAppointment == null || appointment.time < nextAppointment.time)
                nextAppointment = appointment
        }
    })

    if (nextAppointment == null)
        // return 'This patient has not yet planned their next appointment.'
        return ''

    var questionKeys = Object.keys(nextAppointment).filter((k) => k.includes('question'))
    var topicCount = questionKeys.length

    result.push(patient.name, ' wanted to discuss ', topicCount,
        ' topics at their next appointment on ',
        this.formatDate(nextAppointment.time, true, true), '.\n')

    // TODO: check if another appointment within a 7 day buffer, and show all upcoming appointments

    questionKeys.forEach((key) => {
        // result.push(key)
        result.push('\n', sectionTitle(key), '\n')
        nextAppointment[key].forEach((question) => {
            result.push(question, '\n')
        })
    })

    // //find most recent appointment
    // let mostRecent = 0
    // let recentObj = {}
    // Object.keys(analysis).forEach((appointment) => {
    //     analysis[appointment].forEach((recording) => {
    //         if (recording.time > mostRecent)
    //             mostRecent = recording.time
    //             recentObj = recording
    //     })
    // })
    //
    // var date = new Date(recentObj.time)
    // date = moment(date).format('MMM D');
    //
    // var numQ = 0
    // Object.keys(recentObj).forEach((attribute) => {
    //     if (attribute.includes('question')) {
    //         numQ++
    //     }
    // })
    //
    // report += this.fullName + " wanted to discuss " + numQ + " topics at " + this.pronouns[2] + " appointment on " + date + ". "
    //
    // //for each attribute in the most recent appointment object, push  title, question to report
    // Object.keys(recentObj).forEach((attribute) => {
    //     if (attribute.includes('question')) {
    //         var q = recentObj[attribute]
    //         var retTitle = attribute.replace('_question', "").replace(/_/g, " ").toUpperCase()
    //         let row = [retTitle]
    //
    //         if (q.length > 0){
    //             if (q.length == 1) {
    //                 report += "We discussed " + q[0].replace("?", "").lowercaseFirst() + " in the " + retTitle + " section. "
    //
    //             }
    //             else {
    //                 report += "In the " + retTitle + " section, " + this.pronouns[2] + " questions were related to "
    //
    //                 // report += "Questions included "
    //                 for (var i = 0; i < q.length; i++) {
    //                     if (i != q.length - 1)
    //                         report += String.fromCharCode(94 + i+3) + ") " + q[i].replace("?", "").lowercaseFirst()  + ", "
    //                     else
    //                         report += String.fromCharCode(94 + i+3) + ") " + q[i].replace("?", "").lowercaseFirst()  + ". "
    //                 }
    //             }
    //
    //         }
    //     }
    // })

    return result.join('').trim()
}
